import React, { useContext } from "react";
import { ThemeContext, ThemeConstants } from "../App";

export const Menu = ({
  accountMenuActive,
  ordersMenuActive,
  cardsMenuActive,
}) => {
  const currentTheme = process.env.REACT_APP_THEME;
  const themeConfig = useContext(ThemeContext);
  const themeConstants = useContext(ThemeConstants);

  return (
    <div className="menu">
      <a
        href={themeConstants.SHOP_URL}
        className={`flex sm:hidden ml-8 text-base underline ${
          currentTheme === "homelink" ? "mt-5 lg:mt-36 text-white" : "mt-24"
        }`}
      >
        Continue Shopping
      </a>
      <div
        className={`nav-menu p-4 mx-auto max-w-5xl flex flex-col sm:flex-row justify-center ${
          currentTheme === "homelink" ? "mt-0 sm:mt-36" : "mt-0 sm:mt-24"
        }`}
      >
        <a href="/" className="m-4 w-auto sm:w-full lg:w-full">
          <div
            className={`p-3 sm:p-2 lg:p-6 cursor-pointer rounded-md ${
              accountMenuActive
                ? `${themeConfig.secondaryNavActiveMenuItem} shadow-md`
                : "border border-gray-300"
            } flex flex-row sm:flex-col lg:flex-row justify-start items-center ${
              themeConfig.secondaryNavMenuItemBgColor
            }`}
          >
            <span>
              <i className="text-3xl text-gray-600 fa fa-user-circle"></i>
            </span>
            <div className="flex flex-col ml-4 sm:ml-0 lg:ml-4 items-start sm:items-center lg:items-start">
              <p className="text-lg">My Account</p>
              <p className="text-xs">View your user information.</p>
            </div>
          </div>
        </a>

        <a href="/sales" className="m-4 w-auto sm:w-full lg:w-full">
          <div
            className={`p-3 sm:p-2 lg:p-6 cursor-pointer rounded-md ${
              ordersMenuActive
                ? `${themeConfig.secondaryNavActiveMenuItem} shadow-md`
                : "border border-gray-300"
            } flex flex-row sm:flex-col lg:flex-row justify-start items-center ${
              themeConfig.secondaryNavMenuItemBgColor
            }`}
          >
            <span>
              <i className={`text-3xl text-gray-600 fa fa-box-open`}></i>
            </span>
            <div className="flex flex-col ml-4 sm:ml-0 lg:ml-4 items-start sm:items-center lg:items-start">
              <p className="text-lg">My Orders</p>
              <p className="text-xs">View your orders.</p>
            </div>
          </div>
        </a>

        <a href="/payment-methods" className="m-4 w-auto sm:w-full lg:w-full">
          <div
            className={`p-3 sm:p-2 lg:p-6 cursor-pointer rounded-md ${
              cardsMenuActive
                ? `${themeConfig.secondaryNavActiveMenuItem} shadow-md`
                : "border border-gray-300"
            } flex flex-row sm:flex-col lg:flex-row justify-start items-center ${
              themeConfig.secondaryNavMenuItemBgColor
            }`}
          >
            <span>
              <i className="text-3xl text-gray-600 fa fa-credit-card"></i>
            </span>
            <div className="flex flex-col ml-4 sm:ml-0 lg:ml-4 items-start sm:items-center lg:items-start">
              <p className="text-lg">Payment Methods</p>
              <p className="text-xs">Manage your saved cards.</p>
            </div>
          </div>
        </a>
      </div>
    </div>
  );
};

export default Menu;
